<template>
  <div class="main-loading">
    <VaInnerLoading loading :size="40" color="#fff"> </VaInnerLoading>
  </div>
</template>

<style lang="scss" scoped>
.main-loading {
  background-color: rgba(0, 0, 0, 0.509);
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
